import Site from './Site';

export default class SiteUS extends Site {
  constructor () {
    super();
    this.currencyCode = 'USD';
    this.shortWeight = 'lbs';
    this.siteCode = 'US';
    this.maxGoalValue = 200;
    this.minimumBetValue = 200;
    this.convertionRate = 1;
    this.siteName = 'the U.S';
    this.moneyText = 'US Dollars'
  }

  useSI() {
    return false;
  }

  convertedGoal() {
    return 30;
  }
}
